var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pb-3", attrs: { role: "main", id: "instructions" } },
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("AidTargetYearlyReport.Title")))]),
      _vm._v(" "),
      _c("div", {
        domProps: {
          innerHTML: _vm._s(
            _vm.$t("AidTargetYearlyReport.Instructions.TechnicalInstructions")
          )
        }
      }),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(_vm._s(_vm.$t("AidTargetYearlyReport.Attachments.Title")))
      ]),
      _vm._v(" "),
      _c("div", [
        _c("ul", [
          _c("li", [
            _c("b", [
              _vm._v(
                _vm._s(
                  _vm.$t("AidTargetYearlyReport.Attachments.IncomeStatement")
                )
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "AidTargetYearlyReport.Attachments.IncomeStatement_Instructions"
                  )
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("b", [
              _vm._v(
                _vm._s(
                  _vm.$t("AidTargetYearlyReport.Attachments.DelegationSummary")
                )
              )
            ]),
            _vm._v(" "),
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t(
                    "AidTargetYearlyReport.Attachments.DelegationSummary_Instructions"
                  )
                )
              }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v(_vm._s(_vm.$t("AidTargetYearlyReport.Profits.Title")))]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(_vm._s(_vm.$t("AidTargetYearlyReport.Profits.Breakdown")))
      ]),
      _vm._v(" "),
      _c("div", [
        _c("ul", [
          _c("li", [
            _c("b", [
              _vm._v(_vm._s(_vm.$t("AidTargetYearlyReport.Profits.AppliedAid")))
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "AidTargetYearlyReport.Profits.AppliedAid_Instructions"
                  )
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("b", [
              _vm._v(
                _vm._s(
                  _vm.$t("AidTargetYearlyReport.Profits.AdvancesOrDeferred")
                )
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "AidTargetYearlyReport.Profits.AdvancesOrDeferred_Instructions"
                  )
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("b", [
              _vm._v(_vm._s(_vm.$t("AidTargetYearlyReport.Profits.AddNew")))
            ]),
            _vm._v(" "),
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("AidTargetYearlyReport.Profits.AddNew_Instructions")
                )
              }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(_vm.$t("AidTargetYearlyReport.Profits.GrantorsAndPurposes"))
        )
      ]),
      _vm._v(" "),
      _c("p", {
        domProps: {
          innerHTML: _vm._s(
            _vm.$t(
              "AidTargetYearlyReport.Profits.GrantorsAndPurposes_Instructions"
            )
          )
        }
      }),
      _vm._v(" "),
      _c("h2", [_vm._v(_vm._s(_vm.$t("AidTargetYearlyReport.Expenses")))]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(_vm.$t("AidTargetYearlyReport.PersonnelExpenses.HasPersonnel"))
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "AidTargetYearlyReport.PersonnelExpenses.HasPersonnel_Instructions"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t("AidTargetYearlyReport.PersonnelExpenses.SalaryItems.Title")
          )
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "AidTargetYearlyReport.PersonnelExpenses.SalaryItems.Title_Instructions"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "AidTargetYearlyReport.PersonnelExpenses.SalaryItems.JobTitle"
                )
              )
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "AidTargetYearlyReport.PersonnelExpenses.SalaryItems.JobTitle_Instructions"
                )
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "AidTargetYearlyReport.PersonnelExpenses.SalaryItems.Description"
                )
              )
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "AidTargetYearlyReport.PersonnelExpenses.SalaryItems.Description_Instructions"
                )
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "AidTargetYearlyReport.PersonnelExpenses.SalaryItems.GrossSalary"
                )
              )
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "AidTargetYearlyReport.PersonnelExpenses.SalaryItems.GrossSalary_Instructions"
                )
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "AidTargetYearlyReport.PersonnelExpenses.SalaryItems.WorkingHours"
                )
              )
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "AidTargetYearlyReport.PersonnelExpenses.SalaryItems.WorkingHours_Instructions"
                )
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "AidTargetYearlyReport.PersonnelExpenses.SalaryItems.WorkingHoursPercent"
                )
              )
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "AidTargetYearlyReport.PersonnelExpenses.SalaryItems.WorkingHoursPercent_Instructions"
                )
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "AidTargetYearlyReport.PersonnelExpenses.SalaryItems.IsDivided"
                )
              )
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "AidTargetYearlyReport.PersonnelExpenses.SalaryItems.IsDivided_Instructions"
                )
              )
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "AidTargetYearlyReport.PersonnelExpenses.AidYearPersonnelExpenses.Title"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "AidTargetYearlyReport.PersonnelExpenses.AidYearPersonnelExpenses.Title_Instructions"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "AidTargetYearlyReport.PersonnelExpenses.AidYearPersonnelExpenses.Salaries"
                )
              )
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "AidTargetYearlyReport.PersonnelExpenses.AidYearPersonnelExpenses.Salaries_Instructions"
                )
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "AidTargetYearlyReport.PersonnelExpenses.AidYearPersonnelExpenses.Rewards"
                )
              )
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "AidTargetYearlyReport.PersonnelExpenses.AidYearPersonnelExpenses.Rewards_Instructions"
                )
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "AidTargetYearlyReport.PersonnelExpenses.AidYearPersonnelExpenses.HourlyWages"
                )
              )
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "AidTargetYearlyReport.PersonnelExpenses.AidYearPersonnelExpenses.HourlyWages_Instructions"
                )
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "AidTargetYearlyReport.PersonnelExpenses.AidYearPersonnelExpenses.HolidayPays"
                )
              )
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "AidTargetYearlyReport.PersonnelExpenses.AidYearPersonnelExpenses.HolidayPays_Instructions"
                )
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "AidTargetYearlyReport.PersonnelExpenses.AidYearPersonnelExpenses.Pensions"
                )
              )
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "AidTargetYearlyReport.PersonnelExpenses.AidYearPersonnelExpenses.Pensions_Instructions"
                )
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "AidTargetYearlyReport.PersonnelExpenses.AidYearPersonnelExpenses.StatutoryPersonnelCosts"
                )
              )
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "AidTargetYearlyReport.PersonnelExpenses.AidYearPersonnelExpenses.StatutoryPersonnelCosts_Instructions"
                )
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "AidTargetYearlyReport.PersonnelExpenses.AidYearPersonnelExpenses.VoluntaryStaffCosts"
                )
              )
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "AidTargetYearlyReport.PersonnelExpenses.AidYearPersonnelExpenses.VoluntaryStaffCosts_Instructions"
                )
              )
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "ml-3" }, [
        _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.FurtherDescription")))]),
        _vm._v(" "),
        _c("p", { staticClass: "question" }, [
          _vm._v(
            _vm._s(
              _vm.$t(
                "AidTargetYearlyReport.PersonnelExpenses.AidYearPersonnelExpenses.HourlyWages_Details"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.FurtherDescription")))]),
        _vm._v(" "),
        _c("p", { staticClass: "question" }, [
          _vm._v(
            _vm._s(
              _vm.$t(
                "AidTargetYearlyReport.PersonnelExpenses.DeviationExplanation"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "AidTargetYearlyReport.PersonnelExpenses.DeviationExplanation_Instructions"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(_vm.$t("AidTargetYearlyReport.Premises.PremiseTypes.Title"))
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "AidTargetYearlyReport.Premises.PremiseTypes.Title_Instructions"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "ml-3" }, [
        _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
        _vm._v(" "),
        _c("p", { staticClass: "question" }, [
          _vm._v(
            _vm._s(_vm.$t("AidTargetYearlyReport.Premises.OwnPremises.Title"))
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "AidTargetYearlyReport.Premises.OwnPremises.Title_Instructions"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
        _vm._v(" "),
        _c("p", { staticClass: "question" }, [
          _vm._v(
            _vm._s(
              _vm.$t("AidTargetYearlyReport.Premises.RelatedPremises.Title")
            )
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "AidTargetYearlyReport.Premises.RelatedPremises.Title_Instructions"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
        _vm._v(" "),
        _c("p", { staticClass: "question" }, [
          _vm._v(
            _vm._s(
              _vm.$t("AidTargetYearlyReport.Premises.RentalPremises.Title")
            )
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "AidTargetYearlyReport.Premises.RentalPremises.Title_Instructions"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
        _vm._v(" "),
        _c("p", { staticClass: "question" }, [
          _vm._v(_vm._s(_vm.$t("AidTargetYearlyReport.Premises.OtherPremises")))
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "AidTargetYearlyReport.Premises.OtherPremises_Instructions"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(_vm._s(_vm.$t("AidTargetYearlyReport.PremiseExpenses.Title")))
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t("AidTargetYearlyReport.PremiseExpenses.Title_Instructions")
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(_vm.$t("AidTargetYearlyReport.OperationalExpenses.Breakdown"))
        )
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "AidTargetYearlyReport.OperationalExpenses.ExternalServices"
                )
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.$t("AidTargetYearlyReport.OperationalExpenses.Procurements")
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(_vm.$t("AidTargetYearlyReport.OperationalExpenses.Travel"))
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(_vm.$t("AidTargetYearlyReport.OperationalExpenses.Other"))
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.$t("AidTargetYearlyReport.OperationalExpenses.Delegated")
              )
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "AidTargetYearlyReport.OperationalExpenses.Delegated_Instructions"
                )
              )
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("h3", [
        _vm._v(_vm._s(_vm.$t("AidTargetYearlyReport.GeneralExpenses.Title")))
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t("AidTargetYearlyReport.GeneralExpenses.Title_Instructions")
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t("AidTargetYearlyReport.GeneralExpenses.Breakdown.Title")
          )
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "AidTargetYearlyReport.GeneralExpenses.Breakdown.Title_Instructions"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.$t("AidTargetYearlyReport.GeneralExpenses.Breakdown.AddNew")
              )
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(_vm.$t("AidTargetYearlyReport.GeneralExpenses.TotalTitle"))
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "AidTargetYearlyReport.GeneralExpenses.TotalTitle_Instructions"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "AidTargetYearlyReport.GeneralExpenses.AidTargetedPercentage"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "AidTargetYearlyReport.GeneralExpenses.AidTargetedPercentage_Instructions"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "AidTargetYearlyReport.ExternalServices.AcquisitionsMadeOrExternalServicesUsed"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "AidTargetYearlyReport.ExternalServices.AcquisitionsAndExternalServices"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mb-0" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "AidTargetYearlyReport.ExternalServices.AcquisitionsAndExternalServices_Instructions"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "ml-3" }, [
        _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Section")))]),
        _vm._v(" "),
        _c("p", { staticClass: "question" }, [
          _vm._v(
            _vm._s(
              _vm.$t(
                "AidTargetYearlyReport.ExternalServices.AcquisitionOrService"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c("b", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "AidTargetYearlyReport.ExternalServices.AcquisitionOrService"
                  )
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("b", [
              _vm._v(
                _vm._s(_vm.$t("AidTargetYearlyReport.ExternalServices.Source"))
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("b", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "AidTargetYearlyReport.ExternalServices.RelatedPartyAcquisition"
                  )
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("b", [
              _vm._v(
                _vm._s(_vm.$t("AidTargetYearlyReport.ExternalServices.Price"))
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("b", [
              _vm._v(
                _vm._s(
                  _vm.$t("AidTargetYearlyReport.ExternalServices.TenderStatus")
                )
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(_vm._s(_vm.$t("AidTargetYearlyReport.Totals.Title")))
      ]),
      _vm._v(" "),
      _c("p", {
        domProps: {
          innerHTML: _vm._s(
            _vm.$t("AidTargetYearlyReport.Totals.Title_Instructions")
          )
        }
      }),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t("AidTargetYearlyReport.Totals.BudgetedDepositOrReceivable")
          )
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "AidTargetYearlyReport.Totals.BudgetedDepositOrReceivable_Instructions"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "AidTargetYearlyReport.Totals.ExplanationOfBudgetedAndTotalDiscrepancy"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "AidTargetYearlyReport.Totals.ExplanationOfBudgetedAndTotalDiscrepancy_Instructions"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "AidTargetYearlyReport.Totals.NextYearApplicationDeferredAmountWithoutYear"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "AidTargetYearlyReport.Totals.NextYearApplicationDeferredAmount_Instructions"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "AidTargetYearlyReport.Totals.ExplanationOfDeferredDiscrepancy"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(_vm._s(_vm.$t("AidTargetYearlyReport.AdditionalInformation")))
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t("AidTargetYearlyReport.AdditionalInformation_Instructions")
          )
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }